import * as Yup from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { JobApplicationType } from '../../../domain/types';
import { COUNTRY, LINKEDIN_REGEX } from '../../../constants';
import { CreateJobApplicationFormSchemaOptions } from './types';

export const createJobApplicationFormSchema = (options: CreateJobApplicationFormSchemaOptions = {}) => {
  const { skipSource = false } = options;

  return (
    Yup.object().shape({
      name: Yup.string().required('Il campo è obbligatorio'),
      phoneNumber: Yup
        .string()
        .when('email', {
          is: (email: string) => !email || email.length === 0,
          then: (schema) => schema.required('Devi inserire numero di telefono o email'),
          otherwise: (schema) => schema.notRequired(),
        })
        .test('isValid', 'Inserisci un numero di telefono valido', (value: string | undefined) => !value || isValidPhoneNumber(value, COUNTRY)),
      email: Yup
        .string()
        .trim()
        .email('Inserisci un indirizzo email valido')
        .when('phoneNumber', {
          is: (phoneNumber: string) => !phoneNumber || phoneNumber.length === 0,
          then: (schema) => schema.required('Devi inserire email o numero di telefono'),
          otherwise: (schema) => schema.notRequired(),
        }),
      linkedIn: Yup
        .string()
        .matches(LINKEDIN_REGEX, 'Inserisci un URL LinkedIn valido')
        .notRequired(),
      applicationType: Yup.string().required(),
      provinces: Yup.array().when('applicationType', {
        is: JobApplicationType.SALES,
        then: (schema) => schema.min(1, 'Devi selezionare almeno una provincia'),
        otherwise: (schema) => schema.notRequired(),
      }),
      jobPosition: Yup
        .object({
          id: Yup.string().required('Il ruolo è richiesto'),
        }),
      source: Yup
        .string()
        .when([], {
          is: () => !skipSource,
          then: (schema) => schema.required('Il campo è obbligatorio'),
          otherwise: (schema) => schema.notRequired(),
        }),
      experience: Yup.string().notRequired(),
      isEmployed: Yup.string().notRequired(),
      hasLicense: Yup.boolean().when('applicationType', {
        is: JobApplicationType.SALES,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired(),
      }),
      licenseId: Yup.string().notRequired(),
    }, [['email', 'phoneNumber']])
  );
};
